module.exports = __webpack_public_path__ + "img/re-sent-rxnt-active-icon-new.005e6dc1.svg";